import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import Loader from "../../../organisms/loader/Loader";
import { AUDIENCE_GET_FILES_DETAILS } from "../../../endpoints";
import { formatDateDifference } from "../../utils/tools";

const extLabel = (file) => {
  const name = file?.file_name || "";
  const byName = name.includes(".") ? name.split(".").pop() : "";
  const byType = (file?.file_type || "").split("/").pop();
  return (byName || byType || "file").toUpperCase().slice(0, 4);
};

function FilesTab({ audienceId, token }) {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");

  useEffect(() => {
    let alive = true;
    setLoading(true);
    axios
      .get(AUDIENCE_GET_FILES_DETAILS(audienceId), { headers: { Authorization: token } })
      .then(({ data }) => { if (alive) setFiles(data.records || []); })
      .catch(() => {})
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [audienceId, token]);

  const filtered = useMemo(() => {
    const s = q.trim().toLowerCase();
    if (!s) return files;
    return files.filter((f) => (f.file_name || "").toLowerCase().includes(s));
  }, [files, q]);

  if (loading) return <div className="lp-pad"><Loader /></div>;

  return (
    <div className="lp-pad">
      <div className="lp-files__bar">
        <div className="lp-search">
          <span className="lp-search__mag" />
          <input placeholder="Search file…" value={q} onChange={(e) => setQ(e.target.value)} />
        </div>
        <span className="lp-files__count">Total {files.length} file{files.length === 1 ? "" : "s"}</span>
      </div>
      {filtered.length === 0 ? (
        <div className="lp-empty-inline">No files{q ? " match your search" : " uploaded"}.</div>
      ) : filtered.map((f, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <div className="lp-file" key={f.id || i}>
          <span className="lp-file__ft">{extLabel(f)}</span>
          <div className="lp-file__meta">
            <div className="lp-file__name">{f.file_name || "Untitled file"}</div>
            <div className="lp-file__date">{f.updated_at ? formatDateDifference(f.updated_at) : ""}</div>
          </div>
          {f.file_url
            ? <a className="lp-file__go" href={f.file_url} target="_blank" rel="noreferrer" aria-label="Open file">&#8599;</a>
            : <span className="lp-file__go" />}
        </div>
      ))}
    </div>
  );
}

export default FilesTab;
